import React from 'react'
import './Ingredients.css'
import Close from '../../../../assets/img/arrow-back.png'
import CloseX from '../../../../assets/img/close-outline.png'
import Button from '../../../../components/Button'
import classnames from 'classnames'

import Modal from 'react-modal'

class IngredientsInfo extends React.Component {
  state = {
    ingredientsModalIsOpen: false,
    selectedIngredient: null
  }

  toggleIngredientsModal = (selectedIngredient = null) => {
    this.setState(prevState => ({
      ingredientsModalIsOpen: !prevState.ingredientsModalIsOpen,
      selectedIngredient
    }))
  }

  selectIngredient = (selectedIngredient = null) => {
    this.setState({ selectedIngredient })
  }

  render() {
    const { ingredientsModalIsOpen, selectedIngredient } = this.state
    const { mealDetail, isLoading } = this.props

    const ingredients = mealDetail.ingredients || []

    return (
      <div className="ingredients ingredient-desk" id="ingredients-container">
        <h2 className={classnames('title-section', { loading: isLoading })}>
          Ingredients
        </h2>
        <IngredientsModal
          isOpen={ingredientsModalIsOpen}
          onRequestClose={() => this.toggleIngredientsModal()}
          onSelectIngredient={this.selectIngredient}
          ingredients={ingredients}
          selectedIngredient={selectedIngredient}
        />
        <div className="row">
          <div className="row">
            {ingredients.slice(0, 6).map(ingredient => {
              return (
                <div
                  className={classnames('ingredient item-desktop', {
                    loading: isLoading
                  })}
                  key={ingredient.componentCode}
                  onClick={() => {
                    if (!isLoading) {
                      this.toggleIngredientsModal(ingredient)
                    }
                  }}>
                  <div
                    style={{ backgroundImage: `url(${ingredient.image})` }}
                  />
                  <p>
                    {ingredient.name
                      ? ingredient.name
                      : ingredient.componentCode
                      ? ingredient.componentCode
                      : ingredient.value}
                  </p>
                </div>
              )
            })}
          </div>
        </div>
        {!isLoading && ingredients.length > 6 && (
          <div className="row">
            <Button large onClick={() => this.toggleIngredientsModal()}>
              View all ingredients
            </Button>
          </div>
        )}
      </div>
    )
  }
}

const IngredientsModal = ({
  ingredients,
  selectedIngredient,
  onRequestClose,
  isOpen,
  onSelectIngredient
}) => {
  return (
    <Modal
      isOpen={isOpen}
      className="modal-ingredient"
      overlayClassName="modal-ingredient-overlay"
      onRequestClose={onRequestClose}>
      {selectedIngredient ? (
        <div className="ingredient-body">
          <div className="header-modal">
            <h2 className="title-section">Ingredients</h2>
            <img alt="close" src={CloseX} onClick={onRequestClose} />
          </div>
          <div className="ingredient-body">
            <div className="close" onClick={() => onSelectIngredient()}>
              <img className="close-img" src={Close} alt="close" />
              <span>Back</span>
            </div>
            <div className="data-ingredient">
              <img
                className="img-ingredient"
                src={selectedIngredient.image}
                alt={selectedIngredient.componentCode}
              />
              <h2>{selectedIngredient.name}</h2>
            </div>

            <div className="ingredient-description">
              <div className="description-body">
                {selectedIngredient.description}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="ingredients">
          <div className="modal-body">
            <div className="header-modal">
              <h2 className="title-section">Ingredients</h2>
              <img alt="close" src={CloseX} onClick={onRequestClose} />
            </div>
            <div className="row">
              <div className="row-modal">
                {ingredients.map(ingredient => {
                  return (
                    <div
                      className="ingredient item-modal"
                      key={ingredient.componentCode}
                      onClick={() => onSelectIngredient(ingredient)}>
                      <div
                        style={{ backgroundImage: `url(${ingredient.image})` }}
                      />
                      <p>
                        {ingredient.name
                          ? ingredient.name
                          : ingredient.componentCode
                          ? ingredient.componentCode
                          : ingredient.value}
                      </p>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  )
}

export default IngredientsInfo



// WEBPACK FOOTER //
// ./src/modules/MealDetail/components/Ingredients/index.js